import React from 'react'
import NavLink from '../../components/Routes/NavLink';

export default class WarrantyUpgradeTemplate extends React.Component {
    componentDidMount() {
    }

    render(){
        return (
            <div>
                <div style={{textAlign: "center"}}>
                    <div class="row">
                        <div class="main-page-header-row col-md-12">
                            <div class="row">
                                <span class="main-page-header-title">Available with an Enterprise Subscription</span>
                            </div>
                            <div class="row" style={{marginTop: "10px"}}>
                                <NavLink to={"/subscription"}>
                                    <button type="button" id="add-owner" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off">
                                        Upgrade Plan
                                    </button>
                                    <div class="clearfix"></div>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/maintenance.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'top', backgroundSize: 'contain', minHeight: '560px'}}></div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/views/Warranty/WarrantyUpgrade.jsx